import { render, staticRenderFns } from "./ReferentielMainView.vue?vue&type=template&id=ff63a6c8"
import script from "./ReferentielMainView.vue?vue&type=script&lang=js"
export * from "./ReferentielMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports